<neo-menu
  #neoMenu="neoMenu"
  [xPosition]="xPosition()"
  [yPosition]="yPosition()"
  [attr.aut-id]="autId()"
>
  <ng-content></ng-content>
</neo-menu>
